import { USER_SAVED_SEARCH } from 'config/api-routes';
import { DELETE, GET, POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

import { UserSavedSearchTarget } from '../types/userSavedSearch.types';
import { ParsedUserSavedSearchQuery } from '../utils/userSavedSearchConverters';

export default class UserSavedSearchService {
  async getUserSavedSearches(userSavedSearchId?: number, queryParams?: Record<string, string>, opts = {}) {
    const response = await GET(USER_SAVED_SEARCH.LIST.GET(userSavedSearchId, queryParams), opts);

    return formatResponse(response);
  }

  async createUserSavedSearch(data: { target: UserSavedSearchTarget; query: ParsedUserSavedSearchQuery }, opts = {}) {
    const response = await POST(USER_SAVED_SEARCH.CREATE.POST(), data, opts);

    return formatResponse(response);
  }

  async deleteUserSavedSearch(savedSearchId: number, opts = {}) {
    const response = await DELETE(USER_SAVED_SEARCH.DELETE.DELETE(savedSearchId), opts);

    return formatResponse(response);
  }
}
